// extracted by css-extract-rspack-plugin
export default {"copyBtn":"copyBtn-sxrNpA","previewLink":"previewLink-yGTx0F","linkInput":"linkInput-ZIsZaJ","copiedIcon":"copiedIcon-wDYHEV"};